import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { companyApi } from '../companyApi';
import { type Company, type CreateCompanyParams } from '../types';
import { MutationKey } from '@shared/config';
import type { AxiosError } from 'axios';
import type { TFormErrorResponse } from '@shared/types';

export const useCreateCompany = (): UseMutationResult<
  Company,
  AxiosError<TFormErrorResponse>,
  CreateCompanyParams
> => {
  return useMutation({
    mutationKey: [MutationKey.CREATE_COMPANY],
    mutationFn: (params: CreateCompanyParams) =>
      companyApi.createCompany(params),
  });
};
